import "@/App.css";
import "@/index.css";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";

function App() {
  return (
    <div className="App min-h-screen bg-[#f5f3ee] text-[#0e0e10]">
      <Landing />
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
